export function checkSlots(el) {
  const nodes = Array.from(el.childNodes);
  return nodes.reduce((memo, node) => {
    const slot = getNodeSlot(node);
    if (slot) {
      memo[slot] = true;
    }
    return memo;
  }, {});
}
export function getSlotValues(el, allowlist) {
  const nodes = Array.from(el.childNodes);
  return nodes.reduce((memo, node) => {
    const slot = getNodeSlot(node);
    if (slot && (!allowlist || allowlist.includes(slot))) {
      memo[slot] = node.cloneNode(true);
    }
    return memo;
  }, {});
}
export function getNodeSlot(node) {
  switch (node.nodeType) {
    case 3:
      {
        if (isWhitespace(node.data)) {
          return null;
        }
        return 'default';
      }
    case 1:
      {
        const slot = node.slot;
        return slot || 'default';
      }
  }
  return null;
}
export function cleanDefaultSlot(component) {
  Array.from(component.childNodes).forEach(child => {
    if (child.nodeType === 3 && isWhitespace(child.textContent)) {
      component.removeChild(child);
    }
  });
}
function isWhitespace(str) {
  return /^\s*$/.test(str);
}
//# sourceMappingURL=slot-utils.js.map